import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ReadyIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "filter",
    {
      id: "file_upload_ready_icon_a",
      width: "271.4%",
      height: "340%",
      x: "-85.7%",
      y: "-85.7%",
      filterUnits: "objectBoundingBox"
    },
    /* @__PURE__ */ React.createElement("feOffset", { dy: "4", in: "SourceAlpha", result: "shadowOffsetOuter1" }),
    /* @__PURE__ */ React.createElement("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "4" }),
    /* @__PURE__ */ React.createElement(
      "feColorMatrix",
      {
        in: "shadowBlurOuter1",
        result: "shadowMatrixOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      }
    ),
    /* @__PURE__ */ React.createElement("feOffset", { in: "SourceAlpha", result: "shadowOffsetOuter2" }),
    /* @__PURE__ */ React.createElement("feGaussianBlur", { in: "shadowOffsetOuter2", result: "shadowBlurOuter2", stdDeviation: "2" }),
    /* @__PURE__ */ React.createElement(
      "feColorMatrix",
      {
        in: "shadowBlurOuter2",
        result: "shadowMatrixOuter2",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      }
    ),
    /* @__PURE__ */ React.createElement("feMerge", null, /* @__PURE__ */ React.createElement("feMergeNode", { in: "shadowMatrixOuter1" }), /* @__PURE__ */ React.createElement("feMergeNode", { in: "shadowMatrixOuter2" }))
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "file_upload_ready_icon_b",
      d: "M16.346 0.167L17.167 0.963 6.97 11.833 0.833 6.925 1.534 6.019 6.861 10.279z"
    }
  )),
  /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(3 6)" }, /* @__PURE__ */ React.createElement(
    "use",
    {
      fill: "#000",
      filter: "url(#file_upload_ready_icon_a)",
      xlinkHref: "#file_upload_ready_icon_b"
    }
  ), /* @__PURE__ */ React.createElement("use", { fill: "#008250", xlinkHref: "#file_upload_ready_icon_b" }))
);

export { ReadyIcon as default };
//# sourceMappingURL=readyIcon.js.map
